import { httpApi } from 'core/httpApi';

export const postLastOpenedStory = async (
    hashId: string,
    signal?: AbortSignal
): Promise<{ hashId: string }> =>
    httpApi.v2.post('stories/last-opened-story', { hashId }, { signal });
